// extracted by mini-css-extract-plugin
export default {"languageToggle":"LanguageToggle_languageToggle__Qizpw","transparent":"LanguageToggle_transparent__iWXeP"};